import React from 'react'
import * as Bs from 'react-bootstrap'
import DocumentTitle from 'react-document-title'
import Input from '_/shared/components/input'
import ConfirmModal from '_/shared/components/confirmModal'

/**
 * Purchase credits page
 */
class PurchaseCredits extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
    router: React.PropTypes.func.isRequired
  }

  state = {
    credits: 0,
    showConfirmModal: false
  }

  changeCredits (evt) {
    this.setState({
      credits: evt.target.value
    })
  }

  confirmPurchase () {
    this.setState({ showConfirmModal: true })
  }

  cancelPurchase () {
    this.setState({ showConfirmModal: false })
  }

  async purchaseCredits (evt) {
    try {
      await this.context.store.post('/purchaseCredits', {
        credits: this.state.credits
      })
      this.context.router.transitionTo('manage-group')
    } catch (er) {
      this.setState({
        stripeError: er.response.body.error
      })
    }
  }

  render () {
    const { account } = this.props
    const { credits, showConfirmModal, stripeError } = this.state

    return (
      <DocumentTitle title="Purchase credits">
        <div>
          <h3>Purchase credits</h3>
          <p>
            Your group currently has <b>{account.getIn(['group','credits'])}</b> credits.
            Credits cost <b>$1.00</b> each.</p>
          {stripeError && <Bs.Alert bsStyle="danger">{stripeError}</Bs.Alert>}
          <Bs.Row>
            <Bs.Col xs={7}>
              <Input
                type="number"
                name="number"
                value={credits}
                onChange={::this.changeCredits}
                label="Credits to purchase" />
              <p>
                <Bs.Button
                  type="submit"
                  onClick={::this.confirmPurchase}
                  bsStyle="primary">
                  Purchase credits
                </Bs.Button>
              </p>
            </Bs.Col>
            <Bs.Col xs={5}>
              <Bs.Well>
                Credits allow members of your group to purchase services and resources in the system.
              </Bs.Well>
            </Bs.Col>
          </Bs.Row>

          {showConfirmModal &&
            <ConfirmModal
              actionText="Yes, purchase"
              onAction={::this.purchaseCredits}
              onCancel={::this.cancelPurchase}
              message={
                <p>
                  Are you sure you want to purchase <b>{credits}</b> credits
                  for <b>${credits}.00</b>?
                </p>
              }
            />
          }
        </div>
      </DocumentTitle>
    )
  }
}

export default PurchaseCredits



// WEBPACK FOOTER //
// ./modules/shared/pages/account/purchaseCredits.js